// App-wide state, plus the event bus everything else listens on.
//
// `state` is a Vue reactive object now, so a template that reads `state.online`
// re-renders when it changes and nothing has to subscribe. The bus stays,
// because two things still need it: modules that react to a change rather than
// render it (the sync addon flushing a queue when the network returns), and
// events that are not state at all.
//
// setState survives so addons written against the old chassis keep working;
// assigning to `state` directly is equally correct now.

import { reactive } from 'vue';
import { createBus } from './util.js';

export const bus = createBus();

export const state = reactive({
  ready: false,
  online: navigator.onLine,
  user: null,        // set by the auth addon, when present
  surface: null,     // id of the currently open sheet/overlay, or null
});

/** Merge into state and announce what changed. */
export function setState(patch) {
  const changed = [];
  for (const [k, v] of Object.entries(patch)) {
    if (state[k] === v) continue;
    state[k] = v;
    changed.push(k);
  }
  if (changed.length) bus.emit('state', { changed, state });
  return state;
}

addEventListener('online', () => setState({ online: true }));
addEventListener('offline', () => setState({ online: false }));
